import type { SVGProps } from "react"

export default function ShareX(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2742 11.5825L21.3475 4.59375H19.8642L14.6208 10.6517L10.4217 4.59375H5.41666L11.7808 13.79L5.41666 21.1046H6.9L12.4342 14.7208L16.8517 21.1046H21.8567L15.2742 11.5825ZM13.1808 13.8717L12.5208 12.9475L7.425 5.67625H9.71666L13.7667 11.5358L14.4267 12.46L19.865 20.0667H17.5733L13.1808 13.8717Z"
        fill="#191919"
      />
    </svg>
  )
}
